import type { RadioOption, SelectOption } from '@/shared/components/ui';

/**
 * Plano B — Email→Ticket. Opções compartilhadas entre o form de CRIAÇÃO
 * (`components/forms/EmailResendForm.tsx`) e o de EDIÇÃO
 * (`components/provider-configs/EmailResendConfig.tsx`) do canal
 * `email-resend` — os dois fluxos convergem para o MESMO copy (Task 7).
 */

/** Modo de criação de ticket a partir de e-mail inbound. */
export const TICKET_CREATION_MODE_OPTIONS: RadioOption[] = [
  {
    value: 'off',
    label: 'Desativado',
    description: 'E-mails recebidos continuam aparecendo como conversas no chat (comportamento atual).',
  },
  {
    value: 'review',
    label: 'Com aprovação (Retenção)',
    description: 'E-mails ficam retidos em uma tela de aprovação antes de virarem tickets.',
  },
  {
    value: 'auto',
    label: 'Automático',
    description: 'Um ticket é criado automaticamente para cada e-mail recebido.',
  },
];

/** Mesmas categorias fixas usadas em `helpdesk/tickets` (`TicketFormDrawer.tsx`). */
export const EMAIL_TICKET_CATEGORY_OPTIONS: SelectOption[] = [
  { value: '', label: 'Nenhuma' },
  { value: 'support', label: 'Suporte Técnico' },
  { value: 'billing', label: 'Financeiro' },
  { value: 'sales', label: 'Comercial' },
  { value: 'feature', label: 'Solicitação' },
  { value: 'bug', label: 'Bug/Erro' },
  { value: 'other', label: 'Outros' },
];

/** Mesmos rótulos pt-BR de `helpdesk/tickets/types` (`TICKET_PRIORITY`). */
export const EMAIL_TICKET_PRIORITY_OPTIONS: SelectOption[] = [
  { value: 'low', label: 'Baixa' },
  { value: 'medium', label: 'Média' },
  { value: 'high', label: 'Alta' },
  { value: 'urgent', label: 'Urgente' },
];
